/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUnitCapabilities} from '../api'

export const useMutationUpdateUnitCapabilities = createReactQueryMutationHook('updateUnitCapabilities', updateUnitCapabilities)
